import { Box, Button, Fade, Modal, Paper, Typography } from '@mui/material'
import React from 'react'
import { useThemes } from '../../components/Theme/theme';

function DeleteLedgerGroup({ open, setOpen, setdeleteId, selectedRow }) {
    const { theme } = useThemes()

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        boxShadow: 24,
        outline: "none",
        borderRadius: "4px"
    };

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    }

    const deleteItem = () => {
        setdeleteId(selectedRow)
        setOpen(false);

    }
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
        >
            <Paper sx={style}>
                <Box sx={{
                    borderRadius: "4px",
                    padding: "15px",
                    textAlign: "center",
                    overflowY: { xs: 'scroll', sm: 'hidden' },
                    '.MuiTableCell-root': {
                        padding: '10px 10px',
                        fontSize: '13px'
                    },
                }}>

                    <Typography sx={{ color: theme?.palette?.TmId.id.toString().includes("9") ? "white" : "rgb(60 60 60)", fontWeight: "bold" }}>
                        Do you want to delete this {selectedRow?.category === "ledger" ? "Ledger" : "Group"}
                    </Typography>

                </Box>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    // flexDirection: { xs: 'column', sm: 'row' },
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                }}>
                    <Button onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >No</Button>
                    <Button color="error" onClick={deleteItem} variant='contained' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >Yes</Button>
                </Box>


            </Paper>
        </Modal>
    )
}

export default DeleteLedgerGroup